import React, { useRef, useState } from "react";
import { IoCloudUploadOutline } from "react-icons/io5";


const FileUpload = ({ onFileSelect }) => {
  const inputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [error, setError] = useState("");

  const maxSize = 25 * 1024 * 1024; // 25MB

  const handleClick = () => {
    inputRef.current.click();
  };

  const handleFile = (file) => {
    if (!file) return;

    if (file.size > maxSize) {
      setError("File size exceeds 25MB");
      return;
    }

    setError("");
    onFileSelect?.(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    handleFile(file);
  };

  return (
    <div className="mt-4">
      <div
        onClick={handleClick}
        onDragOver={(e) => e.preventDefault()}
        onDragEnter={() => setIsDragging(true)}
        onDragLeave={() => setIsDragging(false)}
        onDrop={handleDrop}
        className="text-center p-5 rounded"
        style={{
          border: "2px dashed #f4a261",
          borderRadius: "12px",
          backgroundColor: isDragging ? "#fff3e0" : "#f8f9fa",
          cursor: "pointer",
          transition: "0.2s ease",
        }}
      >
        <div
          className="mb-3 d-flex justify-content-center align-items-center"
          style={{
            width: 60,
            height: 60,
            margin: "0 auto",
            borderRadius: "12px",
            background: "#ffe8cc",
            color: '#f4a261',
            fontSize: "28px",
          }}
        >
          <IoCloudUploadOutline />
        </div>

        <p className="mb-1 fw-semibold">
          <span className="text-primary">Click to Upload</span> or drag and drop
        </p>

        <p className="text-muted small mb-1">
          Upload project briefs, brand guidelines, or technical specs
          (PDF, PNG, JPG, DOCX)
        </p>

        <p className="mt-4 text-muted small">MAX SIZE: 25MB</p>

        {error && <p className="text-danger small mt-2">{error}</p>}

        <input
          ref={inputRef}
          type="file"
          hidden
          accept=".pdf,.png,.jpg,.jpeg,.docx"
          onChange={(e) => handleFile(e.target.files[0])}
        />
      </div>
    </div>
  );
};

export default FileUpload;